import React, { useContext } from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import SocialLink, { SupportedSocialPlatforms } from './SocialLink';
import CdnImage from '../common/CdnImage';
import { StyledWebView } from '../common/StyledWebView';
import ComponentContainer from '../common/ComponentContainer';
import LayoutContext from '../../contexts/Layout';

const TextPlusImage = ({
    facebookLink,
    id,
    image,
    imageLocation = 'left',
    instagramLink,
    nodeTypeAlias = 'TextPlusImage',
    text,
    textBackgroundColor = '#fff',
    twitterLink,
    width,
    hardWidth
}) => {
    const { layout } = useContext(LayoutContext);
    let flexDirection = layout.device.isMobile ? 'column' : 'row';
    let componentWidth = layout.device.isMobile ? hardWidth : Math.floor(hardWidth * 0.5);

    if (imageLocation.equals('Right')) {
        flexDirection = 'row-reverse';
    }

    const content = () => {
        if (layout.device.isMobile) {
            return (
                <View key={id} style={{ flexDirection: 'column', marginVertical: layout.styleGuide.verticalMargin, width: componentWidth }}>
                    <CdnImage alt={text} uri={image.cdnImagePath} style={{ width: componentWidth, height: layout.device.isNative ? 300 : undefined }} width={componentWidth} />
                    <ComponentContainer
                        style={{ width: componentWidth, backgroundColor: textBackgroundColor || '#ffffff', marginHorizontal: layout.styleGuide.spacer1, marginVertical: 0 }}
                    >
                        {!!text && <StyledWebView html={text} width={Math.floor(hardWidth * 0.25)} />}
                        <View style={{ flexDirection: 'row' }}>
                            {!!facebookLink?.externalUrl && (
                                <SocialLink id='tpl-sl-facebook' link={facebookLink.externalUrl} size={20} type={SupportedSocialPlatforms.FACEBOOK} />
                            )}
                            {!!instagramLink?.externalUrl && (
                                <SocialLink id='tpl-sl-instagram' link={instagramLink.externalUrl} size={20} type={SupportedSocialPlatforms.INSTAGRAM} />
                            )}
                            {!!twitterLink?.externalUrl && <SocialLink id='tpl-sl-twitter' link={twitterLink.externalUrl} size={20} type={SupportedSocialPlatforms.TWITTER} />}
                        </View>
                    </ComponentContainer>
                </View>
            );
        } else {
            return (
                <View
                    key={id}
                    style={{ flexDirection: flexDirection, marginBottom: layout.styleGuide.componentSeparator }}
                    dataSet={{ umbracoComponentName: nodeTypeAlias, spacerBottom: `StyleGuide.ComponentSeparator(${layout.styleGuide.componentSeparator})` }}
                >
                    <CdnImage alt={text} uri={image.cdnImagePath} style={{ height: undefined, width: componentWidth }} width={componentWidth} />
                    <View
                        style={{
                            backgroundColor: textBackgroundColor || '#ffffff',
                            marginVertical: 0,
                            // marginTop: layout.styleGuide.spacer2,
                            paddingHorizontal: layout.styleGuide.indent,
                            width: componentWidth
                        }}
                        dataSet={{
                            spacerLeft: `StyleGuide.Indent(${layout.styleGuide.indent})`,
                            spacerRight: `StyleGuide.Indent(${layout.styleGuide.indent})`,
                            spacerTop: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})`
                        }}
                    >
                        {!!text && <StyledWebView html={text} nodeId='textPlusImage' width='50%' />}
                        <View style={{ flexDirection: 'row' }}>
                            {!!facebookLink?.externalUrl && (
                                <SocialLink id='tpl-sl-facebook' link={facebookLink.externalUrl} size={20} type={SupportedSocialPlatforms.FACEBOOK} />
                            )}
                            {!!instagramLink?.externalUrl && (
                                <SocialLink id='tpl-sl-instagram' link={instagramLink.externalUrl} size={20} type={SupportedSocialPlatforms.INSTAGRAM} />
                            )}
                            {!!twitterLink?.externalUrl && <SocialLink id='tpl-sl-twitter' link={twitterLink.externalUrl} size={20} type={SupportedSocialPlatforms.TWITTER} />}
                        </View>
                    </View>
                </View>
            );
        }
    };

    return <View style={{ width: '100%' }}>{content()}</View>;
};

TextPlusImage.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    text: PropTypes.string,
    image: PropTypes.shape({
        cdnImagePath: PropTypes.string
    }),
    imageSrc: PropTypes.string,
    textBackgroundColor: PropTypes.string
};

export default TextPlusImage;
